exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#banner {\n  padding: 32px 0;\n  width: 100%;\n  background-position: top center;\n  display: flex;\n  justify-content: flex-end;\n  background-size: cover;\n}\n#banner .container {\n  display: flex;\n  justify-content: flex-end;\n}", ""]);

